import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './app'
import { makeStore } from './store'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { getReCaptchaSitekey } from '../../utils/config'
import { loadAppState } from './common/fns'

import '../../globals/scss/style.scss'
import './styles/main.scss'

const store = makeStore(loadAppState())
const siteKey = getReCaptchaSitekey(window.location.hostname)

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleReCaptchaProvider>,
  document.getElementById('main') || document.createElement('div'),
)
